import { GatsbyProps } from 'models/gatsby-props';
import { useEffect } from 'react';

interface Props extends GatsbyProps {
    handleLoggedInUser: () => void;
    handleNotLoggedInUser: () => void;
}

export const UserCheck = ({ handleLoggedInUser, handleNotLoggedInUser }: Props) => {
    useEffect(() => {
        const cookies = document.cookie;
        if (cookies.includes('authenticated=true')) {
            handleLoggedInUser();
        } else {
            handleNotLoggedInUser();
        }
    }, []);

    return <></>;
};
